<template>
  <div class="row">
    <div style="clear: both; margin-bottom: 5px; display: block;padding-right: unset;">
      <div style="float: right; margin-right: 2px; z-index: 0;padding-right: unset;">
        <button
            class="btn btn-success settings-action-btn btn-sm"
            type="button"
            @click="triggerSaveSettings"
        >
          <i class="fas fa-save me-1"></i> Zapisz
        </button>
        <button
            class="btn btn-primary settings-action-btn btn-sm"
            @click="openExportSettingsForm()"
        >
          <i class="fas fa-file-export" />
          Eksportuj ustawienia
        </button>

        <button
            v-if="!commonModule.centralInstance"
            class="btn btn-primary settings-action-btn"
            @click="importSettingsFromCentralFtp()"
        >
          <i class="fas fa-download" />
          Importuj ustawienia z centralnego FTP
        </button>
      </div>
    </div>
  </div>

  <b-modal
      v-model="exportSettingsFormDisplayed"
      id="export-settings-form-modal"
      scrollable
      title="Importuj apteki z centrali"
      title-class="font-18"
      hide-footer
      size="xl"
  >
    <div style="text-align: right">
      <button
          class="btn btn-primary"
          style="font-size: 1em !important"
          @click="exportAllSettings()"
      >
        Eksportuj wszystkie ustawienia
      </button>

      <b-dropdown
          class="btn btn-primary"
          style="font-size: 1em !important"
          text="Eksportuj ustawienia dla konkretnego modułu (Kliknij aby wybrać moduł)">
        <b-dropdown-item v-for="moduleName in commonModule.getAvailableModules" :key="moduleName" @select="setModuleNameAndExport($event)">{{moduleName}}</b-dropdown-item>
      </b-dropdown>

      <button
          class="btn btn-danger"
          style="font-size: 1em !important"
          @click="closeExportSettingsForm()"
      >
        Anuluj
      </button>
    </div>
  </b-modal>

  <CommonSettingsEditor
      ref="commonSettingsView"
      :settings="currentSettings"
      @onTestSettingsGroup="testSettingsGroup"
      @onSaveSettings="saveCommonSettings"
      :testButtonTitle="'Testuj połączenie'"
  />
</template>
<script>

import Swal from "sweetalert2";
import CommonSettingsEditor from "@/components/widgets/CommonSettingsEditor.vue";
import {log} from "@/state/pinia/log";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";



export default {
  name: "CommonSettingsList",
  props: {
    fetchSettingsMethod:{
      type: Function,
      default: () => {
      }
    }

  },

  components: {
    CommonSettingsEditor,
  },
  data() {
    return {
      currentSettings: [],
      exportSettingsFormDisplayed: false,
      moduleName: "",
    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
  },

  methods: {
    testSettingsGroup(payload) {
      console.log("testSettingsGroup::",payload);
      const settingsGroup = payload.key;
      const settingsToSave = payload.settingsToSave;
      this.saveCommonSettings(settingsToSave,false).then(()=>{

        if(settingsGroup === "1. Połączenie z centralną aplikacją*") {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.commonModule.httpTestRestConnectionSettings({moduleName:"APP"})

        }else if(settingsGroup === "2. Połączenie z serwerem poczty*"){
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.commonModule.httpTestMailServerConnectionSettings({moduleName:"APP"})

        }else if(settingsGroup === "3. Połączenie FTP*") {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.commonModule.httpTestFtpConnectionSettings({moduleName:"APP"})

        }
      })

    },
    triggerSaveSettings(){
      this.$refs.commonSettingsView.emitSave();
    },
    saveCommonSettings(payload,showSuccessDialog = true) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Zapis ustawień...");
      return this.commonModule.saveSettings(payload).then(() => {
        this.lazyloaderModule.setDisplayLazyLoader(false);
        if(showSuccessDialog){
          Swal.fire({
            title: "Sukces",
            text: "Ustawienia zostały zapisane",
            icon: "success",
            confirmButtonColor: "#34c38f",
          });
        }
        this.refreshSettingsList();
      });
    },

    setModuleNameAndExport(moduleName) {
      log.log(moduleName);
      this.moduleName = moduleName;
      this.exportModuleSettings();
    },

    openExportSettingsForm() {
      this.exportSettingsFormDisplayed = true;
    },
    closeExportSettingsForm() {
      this.exportSettingsFormDisplayed = false;
    },

    exportModuleSettings() {
      var requestPayload = {
        settingsModuleName: this.moduleName,
      };
      this.commonModule.httpExportModuleSettingsToFile(requestPayload).then(() => {
        this.closeExportSettingsForm();
      });
    },

    exportAllSettings() {
      this.commonModule.httpExportAllSettingsToFile().then(() => {
        this.closeExportSettingsForm();
      });
    },

    importSettingsFromCentralFtp() {
      Swal.fire({
        title: "Import ustawień",
        text: "Uwaga import spowoduje nadpisanie wszystkich lokalnych ustawień. Proces jest nieodwracalny. Czy kontynuować?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        dangerMode: true,
      }).then((proceed) => {
        if (proceed.value) {
          this.commonModule.httpImportSettingsFromCentralFtp().then(() => {
            this.refreshSettingsList();
          });
        }
      });
    },

    refreshSettingsList() {
      var requestPayload = {};
      this.commonModule.httpGetAppCommonSettings(requestPayload).then(() => {
        this.currentSettings = JSON.parse(JSON.stringify(this.commonModule.getAppCommonSettings));
        this.commonModule.httpGetAvailableModules();
      });
    //TODO: dopracowac aby przekazywać wyłącznie metode pobierającą ustawienia, save obsłuzyć jako emit, a przyciski wyrzucić powyżej do komponentu
      //TODO: zaimplementować w pozostałych widokach ustawień
      //TODO: Zaimplementować testy
      // this.fetchSettingsMethod().then((fetchedSettings) => {
      //   this.currentSettings =  JSON.parse(JSON.stringify(fetchedSettings));
      // });

    },
  },

  created() {
    this.refreshSettingsList();
  },
};
</script>

<style scoped>


.settings-action-btn {
  margin-right: 4px;
  margin-bottom: 8px;
}


</style>
